import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-25f7e8ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "van-list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_6 = {
  class: "title"
};
import nav_header from '@/components/nav_header.vue';
import search from '@/components/search.vue';
// let infoData = ref([
//     {name:'独家赢钱',tiem:'2023-04-16 00:57:17',title:'106期:惠泽独家赢钱期期准◆禁特十码',id:'441'},
//     {name:'独家赢钱',tiem:'2023-04-16 00:57:17',title:'106期:惠泽独家赢钱期期准◆禁特十码'},
//     {name:'独家赢钱',tiem:'2023-04-16 00:57:17',title:'106期:惠泽独家赢钱期期准◆禁特十码'},
// ])
import axios from 'axios';

import { useRoute, useRouter } from 'vue-router';
import { ref, reactive, onMounted } from 'vue';
export default {
  __name: 'infoList',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    let title = ref('');
    const loading = ref(false);
    const finished = ref(false);
    let ids = ref('');
    let page = ref(1);
    let data = reactive({
      infoData: [
        // {name:'独家赢钱',tiem:'2023-04-16 00:57:17',title:'106期:惠泽独家赢钱期期准◆禁特十码',id:'441'},
      ]
    });
    const onLoad = () => {
      page.value++;
      if (ids.value == '挂牌') {
        gplistFun(page.value);
      } else {
        console.log(1);
        artFun(ids.value, page.value);
      }
    };
    onMounted(() => {
      let id = route.params.id;
      ids.value = route.params.id;
      if (id == '挂牌') {
        gplistFun(1);
      } else {
        artFun(id, 1);
      }
      title.value = route.params.name;
    });
    let listDetails = data => {
      if (ids.value == '挂牌') {
        router.push({
          path: `/detail/${data.id}/挂牌`
        });
      } else {
        router.push({
          path: `/detail/${data.id}/1`
        });
      }
    };
    let artFun = (id, page) => {
      let url = `https://48c.zlapi8.com/api/artlist?cateid=${id}&page=${page}`;
      axios.get(url).then(res => {
        let datas = res.data.data.data;
        if (datas.length == 0) {
          finished.value = true;
        } else {
          loading.value = false;
          data.infoData.push(...datas);
        }
      });
    };
    let gplistFun = page => {
      let url = `https://am.zlapi8.com/api/gplist?type=am48&page=${page}`;
      axios.get(url).then(res => {
        let datas = res.data.data.data;
        if (datas.length == 0) {
          finished.value = true;
        } else {
          loading.value = false;
          data.infoData.push(...datas);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: _unref(title)
      }, null, 8, ["name"]), _createVNode(search, {
        onSubmit: _ctx.submit
      }, null, 8, ["onSubmit"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).infoData, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => _unref(listDetails)(item)
          }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(_unref(title)), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(item.tiem), 1)]), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)], 8, _hoisted_2);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished"])])], 64);
    };
  }
};